import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, AlertTriangleIcon } from 'lucide-react';
interface ChartAnnotationProps {
  type: 'trend-up' | 'trend-down' | 'warning' | 'info';
  text: string;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}
const ChartAnnotation: React.FC<ChartAnnotationProps> = ({
  type,
  text,
  position = 'top-right'
}) => {
  const getIcon = () => {
    switch (type) {
      case 'trend-up':
        return <TrendingUpIcon size={14} className="text-green-600" data-id="element-11681" />;
      case 'trend-down':
        return <TrendingDownIcon size={14} className="text-red-600" data-id="element-11682" />;
      case 'warning':
        return <AlertTriangleIcon size={14} className="text-yellow-600" data-id="element-11683" />;
      default:
        return null;
    }
  };
  const getColor = () => {
    switch (type) {
      case 'trend-up':
        return 'bg-green-50 border-green-200 text-green-700';
      case 'trend-down':
        return 'bg-red-50 border-red-200 text-red-700';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200 text-yellow-700';
      default:
        return 'bg-blue-50 border-blue-200 text-blue-700';
    }
  };
  const getPosition = () => {
    switch (position) {
      case 'top-left':
        return 'top-2 left-2';
      case 'bottom-right':
        return 'bottom-2 right-2';
      case 'bottom-left':
        return 'bottom-2 left-2';
      default:
        return 'top-2 right-2';
    }
  };
  return <div className={`absolute ${getPosition()} flex items-center space-x-1 px-2 py-1 rounded-md border ${getColor()} text-xs font-medium shadow-sm z-10`} data-id="element-11684">
      {getIcon()}
      <span data-id="element-11685">{text}</span>
    </div>;
};
export default ChartAnnotation;